import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';
import { USAePay, USAePayPayload } from '../models/USAePay';
import { ToastService } from './toast.service';
import { ToastType } from '../constants/toast-type';

const controllerRoute = '/usaepay';

@Injectable()
export class USAePayService {

    constructor(
        private apiService: ApiService,
        private toastService: ToastService,
    ) {
    }

    public getUSAePay(): Observable<USAePay> {
        return this.apiService.get(`${controllerRoute}/member-info`).pipe(
            map((response: USAePay) => {
                return response;
            }),
        );
    }

    public getIsUSAePayEligible(): Observable<boolean> {
        return this.apiService.get(`${controllerRoute}/is-usaepay-eligible`).pipe(
            map((response: boolean) => {
                return response;
            }),
        );
    }

    public saveUSAePay(payload: USAePayPayload): Observable<null> {
        return this.apiService.post(`${controllerRoute}/save-credit-info`, payload).pipe(
            map((response: boolean) => {
                this.toastService.buildToastMessage(ToastType.success, 'Saved', 'Credit Information Updated!');
                return null;
            }),
        );
    }

    public updateUSAePay(payload: USAePayPayload): Observable<USAePay> {
        return this.apiService.post(`${controllerRoute}/update-credit-info`, payload).pipe(
            map((response: USAePay) => {
                this.toastService.buildToastMessage(ToastType.success, 'Saved', 'Credit Information Updated!');
                return response;
            }),
        );
    }
}